<template>
    <div>
        <div class="cf mb1">
            <div class="formLabel fl">{{label}}</div>
            <span class="fr mid-gray legal"><b>{{notice}}</b></span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        notice: {
            type: String,
            required: false
        }
    }
};
</script>
